import React from 'react';
import cyan from '@material-ui/core/colors/cyan';
import {hardwareList} from '@components/Test/HardwareIcons';

type msg = 'high' | 'low'
interface TestProp {
   showValue:boolean | undefined,
   msg?:msg
}

const TypeS:React.FC <TestProp> = ({showValue, msg}) => {
  return (
    <>
      {showValue&&
      <div style={{borderRadius:'1rem', background:cyan['400']}}>
        {`Type script sucessfully implemented with `}
        <span style={{fontWeight:'bold'}} >{msg}</span>
      </div>      
      }
      {hardwareList.map(elem => (
        <div style={{padding:'1rem'}} key={elem.value}>{elem.icon}</div> 
      ))}

    </>
  );
};

export default TypeS;
